import { NavBarTypes } from '../../../../sections/sitewide/components/NavBar';

export const getClassesForNavBarLinks = (theme: NavBarTypes.TThemeModes) => {
  return theme === 'light'
    ? { NavBarLinkColor: 'dark', NavBarTextColor: 'black' }
    : { NavBarLinkColor: 'light', NavBarTextColor: 'white' };
};
